const reportWebVitals = (onPerfEntry: any) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const sendMetrics = (metric: any) => {
        const monitorUrl = `${process.env.REACT_APP_API_BASE_URL}/web-vitals-metrics`;
        const data = JSON.stringify(metric);

        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${process.env.REACT_APP_SHOPIFY_API_KEY}`
        }

        if (navigator.sendBeacon) {
          navigator.sendBeacon(monitorUrl, data);
        } else {
          fetch(monitorUrl, {
            method: 'POST',
            body: data,
            headers: {
              'Content-Type': 'application/json',
            },
          })
              .then((response) => {
                if (response.redirected) {
                  console.error('Redirected to:', response.url);
                }
              })
              .catch((error) => console.error('Error:', error));
        }
      };

      getCLS(sendMetrics);
      getFID(sendMetrics);
      getFCP(sendMetrics);
      getLCP(sendMetrics);
      getTTFB(sendMetrics);
    });
  }
};

export default reportWebVitals;
